import { Notification } from './types'
import * as Unverified from './unverifiedEmail'
import * as ValidatedDomain from './validatedDomain'

export const notifications: Notification[] = [
  Unverified.UnverifiedEmailNotification,
  ValidatedDomain.ValidatedDomainNotification,
]
